import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

const EUR_LOCALES = { it: "it-IT", en: "en-GB", fr: "fr-FR", de: "de-DE", es: "es-ES" };

export const fmtEur = (n, lang = "it") => {
  const v = Number(n || 0);
  return v.toLocaleString(EUR_LOCALES[lang] || "it-IT", { style: "currency", currency: "EUR", minimumFractionDigits: 2 });
};

export const fmtDate = (iso, lang = "it") => {
  if (!iso) return "—";
  try {
    let d = new Date(iso);
    // Fallback: handle "DD/MM/YYYY HH:MM" or "DD/MM/YYYY" (Myze CSV / display format)
    if (isNaN(d.getTime()) && typeof iso === "string") {
      const m = iso.match(/^(\d{2})\/(\d{2})\/(\d{4})(?:[\sT](\d{2}):(\d{2}))?/);
      if (m) {
        const [, dd, mm, yyyy, hh = "00", mi = "00"] = m;
        d = new Date(`${yyyy}-${mm}-${dd}T${hh}:${mi}:00`);
      }
    }
    if (isNaN(d.getTime())) return iso;
    return d.toLocaleString(EUR_LOCALES[lang] || "it-IT", {
      day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch { return iso; }
};

export const countryFlag = (code) => {
  if (!code || typeof code !== "string" || code.trim().length !== 2) return "";
  const cc = code.trim().toUpperCase();
  if (!/^[A-Z]{2}$/.test(cc)) return "";
  const codePoints = [...cc].map((c) => 127397 + c.charCodeAt(0));
  return String.fromCodePoint(...codePoints);
};

export const statusClass = (s) => {
  const map = {
    active: "tf-status-success", charged: "tf-status-success", approved: "tf-status-success", paid: "tf-status-success",
    blocked: "tf-status-error", rejected: "tf-status-error", error: "tf-status-error", suspended: "tf-status-error",
    pending: "tf-status-warning", unmatched: "tf-status-warning",
    initiated: "tf-status-info",
  };
  return map[s] || "tf-status-neutral";
};
